























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import moment from "moment";
import { HogarAlerta } from '../../models/hogar/alertas.model';
import { sanitizeRichHtml } from "@/helpers/security";
@Component
export default class HogarAlertasTable extends GenericBTable<
  HogarAlerta
> {
  @Prop() public title!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public hogarId!: string;
  created() {
    this.setupTable();
  }
  setupTable() {
    this.tableConfig.controller = this.controller || "hogaralerta";
    //this.tableConfig.loading = false;
    this.tableConfig.whereParams = this.getWhereParams();
    //this.tableConfig.resource = "alertas";
    this.tableConfig.activeActions = false;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.detailed = true;
    this.tableConfig.rowClass = (row: HogarAlerta, index: number) => row.vigente && "is-warning";
    this.formatColumns();
  }
  getWhereParams() {
    let result = [];
    if (this.hogarId) result.push(`hogarId="${this.hogarId}"`);
    return result.join("&");
  }
  get vigentes(){
    return this.tableConfig.data.filter(x=> x.vigente).length;
  }
  sanitizeMessage(message: string) {
    return sanitizeRichHtml(message);
  }
   onLoadData(response:any){
  this.$emit('vigentes', this.vigentes)
}
  formatColumns() {
    let titulo = new BTableColumn("titulo", "Título");
    let creacion = new BTableColumn("fechaCreacion", "Fecha de creación");
    creacion.type = BTableColumnType.Date;
    let fin = new BTableColumn("fechaFin", "Fecha fin");
    fin.type = BTableColumnType.Date;
    this.tableConfig.insertColumns(titulo, creacion, fin);
  }
  @Watch("hogarId", { immediate: true })
  onhogarIdChange(value: number | undefined | null) {
    if (!value) {
      return;
    }
    this.tableConfig.whereParams = this.getWhereParams();
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
}
